export const apiKey = "2fc5b9871b12b3b636fc862730404eb5";
export const apiUrl = "https://api.themoviedb.org/3/";
export const apiMovieDetails = "movie/";
export const apiBackdrop = "https://image.tmdb.org/t/p/original";
export const apiPersonDetails = "person/";